import React, { useEffect, useRef, useState } from "react";
import PleaseLoginPrompt from "../../components/PleaseLoginPrompt";
import { OlympiacosTheme, MoreTheme } from "../../components/common/mixins.js";
import useMiniSite from "../../hooks/useMiniSite";

const LoginPrompt = () => {
  const loginRef = useRef();
  const { isOlympiacos } = useMiniSite();

  const [mode, setMode] = useState("");

  const prompts = {
    favouriteEventGroup: {
      prompt: tickets_resources.SignInToFavourite,
      icon: "/site/images/icons/heart-favourite.png",
    },
  };

  const isAuthenticated = $("#__HD_RequestVerificationToken").length > 0;

  useEffect(() => {
    initHandlers();
    return () => {
      cleanupHandlers();
    };
  }, []);

  const initHandlers = () => {
    $(document).on("click", ".favourite-icn-container", handleFavouriteEventGroup);
  };

  const cleanupHandlers = () => {
    $(document).off("click", ".favourite-icn-container", handleFavouriteEventGroup);
  };

  const handleAuthAction = (action, input) => {
    if (!isAuthenticated) loginRef.current?.handleOpen();
    else action(input);
  };

  const handleFavouriteEventGroup = (e) => {
    e.stopPropagation();
    e.preventDefault();

    setMode("favouriteEventGroup");

    handleAuthAction((el) => {
      let nodeId = $(el).data("nodeid");
      let favouriteIcon = $(el).find('.favourite-icn');

      if (favouriteIcon.hasClass("favourited")) {
        $.ajax(`/_api/follow/${nodeId}`, { type: "DELETE" });
        favouriteIcon.toggleClass("favourited").toggleClass("not-favourited").show();
      } else {
        $.post(`/_api/follow/${nodeId}`);
        favouriteIcon.toggleClass("favourited").toggleClass("not-favourited");
        
        GoogleAnalytics.trackEvent(GoogleAnalytics.events.AddToFavorites, {
            node_id: nodeId
        });
      }
    }, e.currentTarget);
  };

  return <>
    <MoreTheme />
    {isOlympiacos && <OlympiacosTheme />}
    <PleaseLoginPrompt
        prompt={prompts[mode]?.prompt}
        desc={prompts[mode]?.desc}
        icon={prompts[mode]?.icon}
        ref={loginRef}
    />
  </>;
};

export default LoginPrompt;
